export const colors = {
  blueDark: '#1b2143', // D81022
  blue: '#3F69FF',
  blueLight: '#DCEAFF',
  bluePrimary: '#2F3677',
  redPrimary: '#D81022',
  red: '#F60003',
  green: '#059435',
  lightGreen: '#52c41a',
  yellow: '#FFA800',
  orange: '#FF6B00',
  purple: '#9747FF',
  pink: '#EE348D',
  white: '#ffffff',
  yellowBackground: '#FFF6E5',
  blueBackground: '#ECF0FF',
  blueDarkBackground: '#3D425F',
  blueLightBackground: '#4E548B',
  greyDark: '#595959',
  greyLight: '#D9D9D9',
  grey: '#A8A8A8',
  black: '#000000',
  greyBackground: '#F8F8F8',
  greyBackgroundDark: '#BFBFBF',
}
  
export const themeConfig = {
  "token": {
    "colorPrimary": "#D81022",
    "colorError": "#F60003",
    "colorSuccess": "#059435",
    "colorWarning": "#FFA800",
    "colorLink": '#D81022',
    "fontFamily": "'HKGrotesk', sans-serif",
    "screenXXL": 1400,
    "screenXXLMin": 1400,
    "screenXLMax": 1399
  },
  "components": {
    "Button": {
      "colorLink": "#3F69FF",
      "borderRadius": 5,
      "controlHeight": 36,
      "controlOutlineWidth": 0,
      "marginXS": 10
    },
    "Typography": {
      "fontSizeHeading1": 24,
      "fontSizeHeading2": 18,
      "fontSizeHeading3": 16,
      "fontSizeHeading4": 14,
      "fontSizeHeading5": 12,
      "colorLink": "#3F69FF",
      "fontFamilyCode": "'HKGrotesk', sans-serif"
    },
    "Menu": {
      "itemSelectedBg": "#D81022",
      "itemSelectedColor": "#EFEDE9",
      "itemColor": "#7C7B82",
      "itemHoverBg": "#efbfbf",
      "itemHoverColor": "#D81022",
      "itemHeight": 52,
      "itemMarginInline": 8,
      "itemPaddingInline": 24,
      "itemMarginBlock": 8,
      "iconSize": 24,
      "collapsedIconSize": 24,
      "itemBorderRadius": 5,
    },
    "Input": {
      "controlOutline": "rgba(63, 105, 255, 0.53)",
      "borderRadius": 5,
      "colorIcon": "#d9d9d9",
      "colorPrimary": "#3F69FF",
      "colorPrimaryHover": "#3F69FF",
      "controlOutlineWidth": 1,
      "controlHeight": 36,
      "controlHeightSM": 32,
      "controlPaddingHorizontal": 16,
      "fontSizeIcon": 20,
      "lineHeight": 1,
      "paddingSM": 16
    },
    "Tabs": {
      "colorPrimary": "#D81022",
      "colorPrimaryHover": "#D81022",
      "margin": 24
    },
    "Table": {
      "borderRadius": 0,
      "fontWeightStrong": 400,
      "lineWidth": 0,
      "controlItemBgActive": "#DCEAFF",
      "controlItemBgActiveHover": "#ECF0FF"
    },
    "Pagination": {
      "borderRadius": 2,
      "borderRadiusLG": 2,
      "colorPrimary": "#3F69FF"
    },
    "Checkbox": {
      "borderRadiusSM": 2
    },
    "Card": {
      "paddingLG": 32
    },
    "Switch": {
      "colorPrimary": "#3F69FF",
      "colorPrimaryHover": "#3F69FF"
    },
    "Badge": {
      "fontSizeSM": 10
    },
    "Avatar": {
      "colorTextPlaceholder": "#BFBFBF"
    }
  }
}